import React from 'react';
import { FaUserMd, FaHeart, FaHandHoldingMedical, FaShieldAlt } from 'react-icons/fa';
import { useTranslation } from '../../context/LanguageContext';
import { WhyUsCard } from './Cards';

const WHY_US_REASONS = [
    { icon: <FaUserMd />, titleKey: 'whyUs.reason1Title', textKey: 'whyUs.reason1Text' },
    { icon: <FaHeart />, titleKey: 'whyUs.reason2Title', textKey: 'whyUs.reason2Text' },
    { icon: <FaHandHoldingMedical />, titleKey: 'whyUs.reason3Title', textKey: 'whyUs.reason3Text' },
    { icon: <FaShieldAlt />, titleKey: 'whyUs.reason4Title', textKey: 'whyUs.reason4Text' },
];

/**
 * Home — "Why choose us" reasons grid.
 */
export const HomeWhyUsSection = () => {
    const { t } = useTranslation();

    return (
        <section className="py-14 sm:py-18 md:py-24 lg:py-28 bg-gradient-to-br from-gray-50 to-gold/5">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-10 sm:mb-14">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                        {t('whyUs.title')}
                    </h2>
                    <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
                        {t('whyUs.subtitle')}
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 max-w-4xl mx-auto">
                    {WHY_US_REASONS.map(({ icon, titleKey, textKey }) => (
                        <WhyUsCard key={titleKey} icon={icon} title={t(titleKey)} text={t(textKey)} />
                    ))}
                </div>
            </div>
        </section>
    );
};

